
const ISDEV = process.env.NODE_ENV === 'development' ? true : false
const port = `301`

module.exports = {
    ISDEV: ISDEV,
    devport: parseInt(`18${port}`),
    systemArea: 'jx',
    systemType: 'zzd',
    systemTitle: '长兴清泉水厂智慧管理平台',
    API: `http://127.0.0.1:18403/qbe/`,
    TOKEN: {
        source: ISDEV?'qbe_dev':'qbe',
        version: 'v1.0',
    },
    UPLOAD: `http://127.0.0.1:18403/qbe/upload`
}
